import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { OiqLayoutService } from '../layout.service';
import { OiqLayoutNavItemComponent } from '../nav/nav-item.component';
import { OiqLayoutNavItemModel } from '../nav/nav-item.models';
import { OiqLayoutNavComponent } from '../nav/nav.component';
import { OiqLayoutNavPath } from '../nav/nav.models';

@Component({
  selector: 'oiq-layout-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    MatTooltipModule,
    MatIconModule,
    OiqLayoutNavComponent,
    OiqLayoutNavItemComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'oiq-layout-sidebar',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OiqLayoutSidebarComponent {
  public layout = inject(OiqLayoutService);
  @Input() menu: OiqLayoutNavItemModel[] = [];
  @Input() settingsMenu: OiqLayoutNavItemModel | null = {
    visible: false,
    text: '',
    type: 'button',
  };
  @Input() navPath: OiqLayoutNavPath | null = null;
}
